import { Box, Typography, styled } from '@mui/material';
import { ReactNode } from 'react';
import { MagnifyingGlassIcon } from '../icons';

type notDataType = 'consumers' | 'transaction';

interface NoDataProps {
  type: notDataType;
}

interface NoDataContent {
  text: string;
  customIcon?: ReactNode;
}

const StyledMagnifyingGlassIcon = styled(MagnifyingGlassIcon)(({ theme }) => ({
  width: theme.spacing(15),
  height: theme.spacing(15),
}));

const Container = styled(Box)(({ theme }) => ({
  gap: theme.spacing(4),
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const NoDataMap: Record<notDataType, NoDataContent> = {
  consumers: {
    text: 'No customers found',
  },
  transaction: {
    text: 'No previous transactions \n were found',
  },
};

const StyledText = styled(Typography)(({ theme }) => ({
  textTransform: 'capitalize',
  whiteSpace: 'pre-line',
}));

export const NoData = ({ type }: NoDataProps) => {
  return (
    <Container>
      {NoDataMap[type].customIcon ?? <StyledMagnifyingGlassIcon />}
      <StyledText variant="h4">{NoDataMap[type].text}</StyledText>
    </Container>
  );
};
